<template>
  <svg
    v-for="i in 5"
    :key="i"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 13 11"
    fill="none"
  >
    <path
      d="M6.3916 0L8.13027 3.60693L12.0979 4.1459L9.20483 6.91407L9.91831 10.8541L6.3916 8.958L2.86489 10.8541L3.57838 6.91407L0.685263 4.1459L4.65293 3.60693L6.3916 0Z"
      fill="#2B3483"
    />
  </svg>
</template>
<script>
export default {
  name: "Stars",
};
</script>
